import { InsightCatalogue } from '../InsightCatalogue';
import {
  AggregateOnlyInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface TasksDemandHoursPayload extends AggregateOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_TASKS_DEMAND_HOURS;
    id: string;
    attributes: {
      aggregate: {
        total_demand_hours: InsightMetric;
      };
    };
  };
}

export const parseTasksDemandHoursPayload = (
  payload: BaseInsightPayload
): TasksDemandHoursPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_TASKS_DEMAND_HOURS,
    data.attributes,
    false,
    true
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    aggregate: {
      total_demand_hours: InsightMetric;
    };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_TASKS_DEMAND_HOURS,
      id: data.id,
      attributes: {
        aggregate: {
          total_demand_hours: typedAttributes.aggregate.total_demand_hours,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
